<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <!--    <div class="container">-->
    <!--      <div>-->
    <!--        <br>-->
    <!--        <nav>-->
    <!--          <ul>-->
    <!--            {{$t('footer.compGuide')}}-->
    <!--            <br>-->
    <!--            <li>-->
    <!--              <a href="https://www.creative-tim.com">-->
    <!--                {{$t('footer.compWebsite')}}-->
    <!--              </a>-->
    <!--            </li>-->
    <!--            <li>-->
    <!--              <a href="https://www.creative-tim.com">-->
    <!--                赛事资讯-->
    <!--              </a>-->
    <!--            </li>-->
    <!--            <li>-->
    <!--              <a href="https://www.creative-tim.com">-->
    <!--                赛事资讯-->
    <!--              </a>-->
    <!--            </li>-->
    <!--            <li>-->
    <!--              <a href="https://www.creative-tim.com">-->
    <!--                {{$t('footer.compEntrance')}}-->
    <!--              </a>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--        </nav>-->
    <!--        &lt;!&ndash; &copy; {{ year }}, made with <md-icon>favorite</md-icon> by-->
    <!--        <a href="https://www.creative-tim.com/" target="_blank">Creative Tim</a>-->
    <!--        for a better web. &ndash;&gt;-->
    <!--      </div>-->
    <!--      <div class="copyright">-->
    <!--        <nav>-->
    <!--          <ul v-for="department in this.$global.contact" :key="department.name">-->
    <!--            {{department.name}}-->
    <!--            <li v-for="item in department.member" :key="item.name">-->
    <!--              <a href="https://www.creative-tim.com">-->
    <!--                {{item.name}} : {{item.contact}}-->
    <!--              </a>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--        </nav>-->
    <!--      </div>-->

    <!--    </div>-->
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
